import PropTypes from 'prop-types';
import React from 'react';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
var theme = {
  baseFontSize: 16
}; //DEBTxCYBG pull this from theme component or global?

var baseSpacing = 8;

var spacing = function spacing(value) {
  var fontMultiple = value * baseSpacing;
  var rems = fontMultiple / theme.baseFontSize;
  return rems + "rem";
};

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};
/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
  lewis: {
    xs1: {
      fontSize: 37,
      lineHeight: 1.189
    },
    sm1: {
      fontSize: 37,
      lineHeight: 1.189
    },
    md1: {
      fontSize: 45,
      lineHeight: 1.067
    },
    lg1: {
      fontSize: 52,
      lineHeight: 1.154
    },
    xl1: {
      fontSize: 52,
      lineHeight: 1.154
    }
  },
  skye: {
    xs1: {
      fontSize: 32,
      lineHeight: 1.125
    },
    sm1: {
      fontSize: 32,
      lineHeight: 1.125
    },
    md1: {
      fontSize: 40,
      lineHeight: 1.1
    },
    lg1: {
      fontSize: 45,
      lineHeight: 1.156
    },
    xl1: {
      fontSize: 45,
      lineHeight: 1.156
    }
  },
  shetland: {
    xs1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    sm1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    md1: {
      fontSize: 34,
      lineHeight: 1.176
    },
    lg1: {
      fontSize: 39,
      lineHeight: 1.128
    },
    xl1: {
      fontSize: 39,
      lineHeight: 1.128
    }
  },
  mull: {
    xs1: {
      fontSize: 26,
      lineHeight: 1.231
    },
    sm1: {
      fontSize: 26,
      lineHeight: 1.231
    },
    md1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    lg1: {
      fontSize: 33,
      lineHeight: 1.212
    },
    xl1: {
      fontSize: 33,
      lineHeight: 1.212
    }
  },
  islay: {
    xs1: {
      fontSize: 23,
      lineHeight: 1.217
    },
    sm1: {
      fontSize: 23,
      lineHeight: 1.217
    },
    md1: {
      fontSize: 25,
      lineHeight: 1.28
    },
    lg1: {
      fontSize: 28,
      lineHeight: 1.286
    },
    xl1: {
      fontSize: 28,
      lineHeight: 1.286
    }
  },
  orkney: {
    xs1: {
      fontSize: 20,
      lineHeight: 1.4
    },
    sm1: {
      fontSize: 20,
      lineHeight: 1.4
    },
    md1: {
      fontSize: 22,
      lineHeight: 1.273
    },
    lg1: {
      fontSize: 25,
      lineHeight: 1.28
    },
    xl1: {
      fontSize: 25,
      lineHeight: 1.28
    }
  },
  arran: {
    xs1: {
      fontSize: 18,
      lineHeight: 1.333
    },
    sm1: {
      fontSize: 18,
      lineHeight: 1.333
    },
    md1: {
      fontSize: 19,
      lineHeight: 1.474
    },
    lg1: {
      fontSize: 21,
      lineHeight: 1.333
    },
    xl1: {
      fontSize: 21,
      lineHeight: 1.333
    }
  },
  jura: {
    xs1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    sm1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    md1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    lg1: {
      fontSize: 18,
      lineHeight: 1.556
    },
    xl1: {
      fontSize: 18,
      lineHeight: 1.556
    }
  },
  uist: {
    xs1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    sm1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    md1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    lg1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    xl1: {
      fontSize: 16,
      lineHeight: 1.5
    }
  },
  bute: {
    xs1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    sm1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    md1: {
      fontSize: 13,
      lineHeight: 1.538
    },
    lg1: {
      fontSize: 13,
      lineHeight: 1.538
    },
    xl1: {
      fontSize: 13,
      lineHeight: 1.538
    }
  },
  cumbrae: {
    xs1: {
      fontSize: 11,
      lineHeight: 1.455
    },
    sm1: {
      fontSize: 11,
      lineHeight: 1.455
    },
    md1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    lg1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    xl1: {
      fontSize: 12,
      lineHeight: 1.333
    }
  }
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
  var styles = '';

  if (parseInt(mqBreakpoint) === 0) {
    styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
  } else {
    styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      } \n    ';
  }

  return styles;
};

var fontSizes = {};

for (var _fontSize in fontConfig) {
  if (fontConfig.hasOwnProperty(_fontSize)) {
    var style = '';

    for (var breakpoint in fontConfig[_fontSize]) {
      if (fontConfig[_fontSize].hasOwnProperty(breakpoint)) {
        var _fontConfig$_fontSize = fontConfig[_fontSize][breakpoint],
            size = _fontConfig$_fontSize.fontSize,
            lineHeight = _fontConfig$_fontSize.lineHeight;
        style += generateSASS(breakpoints[breakpoint], size, lineHeight);
      }
    }

    fontSizes[_fontSize] = style;
  }
}

var fontSize = function fontSize(font) {
  return fontSizes[font];
};

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
  nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  caches: caches,
  css: css,
  cx: cx,
  flush: flush,
  getRegisteredStyles: getRegisteredStyles,
  hydrate: hydrate,
  injectGlobal: injectGlobal,
  keyframes: keyframes,
  merge: merge,
  sheet: sheet
});
var styled = createEmotionStyled(emotion, React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(204, 52%, 48%)',
  blueLight: 'hsl(208, 59%, 60%)',
  green: 'hsl(135, 41%, 48%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 42%)',
  grey: 'hsl(0, 0%, 60%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  orange: 'hsl(29, 77%, 56%)',
  red: 'hsl(8, 52%, 50%)',
  purple: 'hsl(282, 25%, 57%)',
  white: 'hsl(0, 0%, 100%)'
};
var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLight = generalPalette.blueLight,
    green = generalPalette.green,
    greenFaint = generalPalette.greenFaint,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    orange = generalPalette.orange,
    red = generalPalette.red,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    purple = generalPalette.purple,
    white = generalPalette.white;
var colours = {
  backgrounds: {
    alternateBody: 'hsl(212, 100%, 97%)',
    alternateHeader: greyLightest,
    component: white,
    modalBackdrop: black,
    modalBackdropOpaque: 'rgba(0, 0, 0, 0.8)',
    shell: 'hsl(0, 0%, 95.3%)',
    tableCell: 'hsl(0, 0%, 97%)',
    tableCellAlternate: 'hsl(0, 71%, 97%)',
    tableCellHeader: 'hsl(0, 0%, 94%)'
  },
  component: {
    border: greyLightest,
    hover: greyLightest
  },
  disabled: {
    background: greyLightest,
    border: greyDarkest
  },
  neutral: {
    black: black,
    grey: grey,
    greyDarker: greyDarker,
    greyDarkest: greyDarkest,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    white: white
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    supplementaryBody: grey
  },
  utility: {
    active: green,
    archived: greyLightest,
    blocker: 'hsl(0, 60%, 96%)',
    deprecated: 'hsl(45, 100%, 51%)',
    empty: 'hsl(0, 0%, 100%)',
    emptyBorder: 'hsl(0, 0%, 40%)',
    error: red,
    errorBodyBackground: 'hsl(8,52%,96%)',
    focus: blueLight,
    help: 'hsl(210, 38%, 91%)',
    inactive: red,
    indicative: orange,
    information: blue,
    notStarted: greyDarker,
    off: grey,
    offDisabled: greyLighter,
    ongoing: purple,
    paused: blue,
    pending: orange,
    success: green,
    successDisabled: greenFaint,
    warning: orange
  },
  utilityLegacy: {
    infoBackground: 'hsl(210, 46%, 91%)',
    infoBorder: 'hsl(204, 52%, 48%)',
    noteBackground: 'hsl(45, 53%, 94%)',
    noteBorder: 'hsl(46, 88%, 24%)',
    tipBackground: 'hsl(125, 21%, 88%)',
    tipBorder: 'hsl(135, 41%, 48%)',
    warningBackground: 'hsl(0, 60%, 96%)',
    warningBorder: 'hsl(8, 52%, 50%)'
  }
};

var _templateObject = taggedTemplateLiteral(['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n'], ['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n']);

var getFontProperties = function getFontProperties(props) {
  var fontProperties = 'font-size: 16px; line-height: 1.5;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('uist') : fontSize('jura'); // }

  return fontProperties;
};

var StyledStandardLabel = styled('div')(_templateObject, getFontProperties, function (props) {
  return props.theme.fonts.standardLabel;
}, function (props) {
  return !props.isFlush && 'margin-bottom: ' + spacing(2);
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing(2);
});

var StandardLabel = function StandardLabel(_ref) {
  var isFlush = _ref.isFlush,
      children = _ref.children;
  return React.createElement(StyledStandardLabel, {
    isFlush: isFlush
  }, children);
};

StandardLabel.propTypes = {
  /** Allows for content to be text or node (for example IconTextDynamic). */
  children: PropTypes.node.isRequired,

  /** Removed margins. */
  isFlush: PropTypes.bool
};
StandardLabel.defaultProps = {
  isFlush: false
};

var _templateObject$1 = taggedTemplateLiteral(['\n\talign-items: center;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\theight: ', ';\n\tmargin-bottom: 1rem;\n\tmargin-right: 1.5rem;\n\tmax-width: 100%;\n\tpadding: 0 ', ';\n\ttransition: all 0.15s;\n\t', '\n\t', '\n\t', '\n\t> div {\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\twhite-space: nowrap;\n\t}\n'], ['\n\talign-items: center;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\theight: ', ';\n\tmargin-bottom: 1rem;\n\tmargin-right: 1.5rem;\n\tmax-width: 100%;\n\tpadding: 0 ', ';\n\ttransition: all 0.15s;\n\t', '\n\t', '\n\t', '\n\t> div {\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\twhite-space: nowrap;\n\t}\n']);

var primaryStyles = function primaryStyles(theme) {
  return '\n\tbackground: ' + theme.colours.primary + ';\n\tborder: 2px solid ' + theme.colours.primary + ';\n\tborder-bottom-color: ' + theme.colours.secondaryAccent + ';\n\tcolor: ' + colours.neutral.white + ';\n\t&:hover {\n\t\tbackground: ' + theme.colours.secondaryAccent + ';\n\t\tborder-color: ' + theme.colours.secondaryAccent + ';\n\t}\n';
};

var secondaryStyles = function secondaryStyles(theme) {
  return '\n\tbackground: ' + colours.neutral.white + ';\n\tborder: 2px solid ' + theme.colours.primary + ';\n\t&:hover {\n\t\tbackground: ' + theme.colours.primary + ';\n\t\tcolor: ' + colours.neutral.white + ';\n\t}\n';
};

var tertiaryStyles = function tertiaryStyles(theme) {
  return '\n\tbackground: none;\n\tborder: 0;\n\tpadding: 0;\n\ttext-decoration: underline;\n\t> div {\n\t\tfont-family: ' + theme.fonts.text.regular + ';\n\t}\n';
};

var StyledWrapper = styled('button')(_templateObject$1, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.colours.primary;
}, spacing(6), spacing(3), function (props) {
  return props.displayType === 'primary' && primaryStyles(props.theme);
}, function (props) {
  return props.displayType === 'secondary' && secondaryStyles(props.theme);
}, function (props) {
  return props.displayType === 'tertiary' && tertiaryStyles(props.theme);
});

var Base = function Base(_ref) {
  var display = _ref.display,
      label = _ref.label,
      onClick = _ref.onClick,
      willSubmitForm = _ref.willSubmitForm;
  return React.createElement(StyledWrapper, {
    displayType: display,
    onClick: onClick,
    type: willSubmitForm ? 'submit' : 'button'
  }, React.createElement(StandardLabel, {
    isFlush: true
  }, React.createElement('span', null, label)));
};

var Back = function Back(_ref2) {
  var onClick = _ref2.onClick;
  return React.createElement(Base, {
    display: 'secondary',
    label: 'Back',
    onClick: onClick
  });
};

var Cancel = function Cancel(_ref3) {
  var onClick = _ref3.onClick;
  return React.createElement(Base, {
    display: 'tertiary',
    label: 'Cancel',
    onClick: onClick
  });
};

var Confirm = function Confirm(_ref4) {
  var onClick = _ref4.onClick,
      willSubmitForm = _ref4.willSubmitForm;
  return React.createElement(Base, {
    display: 'primary',
    label: 'Confirm',
    onClick: onClick,
    willSubmitForm: willSubmitForm
  });
};

var Continue = function Continue(_ref5) {
  var onClick = _ref5.onClick,
      willSubmitForm = _ref5.willSubmitForm;
  return React.createElement(Base, {
    display: 'primary',
    label: 'Continue',
    onClick: onClick,
    willSubmitForm: willSubmitForm
  });
};

var Next = function Next(_ref6) {
  var onClick = _ref6.onClick,
      willSubmitForm = _ref6.willSubmitForm;
  return React.createElement(Base, {
    display: 'primary',
    label: 'Next',
    onClick: onClick,
    willSubmitForm: willSubmitForm
  });
};

var Primary = function Primary(_ref7) {
  var label = _ref7.label,
      onClick = _ref7.onClick,
      willSubmitForm = _ref7.willSubmitForm;
  return React.createElement(Base, {
    display: 'primary',
    label: label,
    onClick: onClick,
    willSubmitForm: willSubmitForm
  });
};

var Secondary = function Secondary(_ref8) {
  var label = _ref8.label,
      onClick = _ref8.onClick;
  return React.createElement(Base, {
    display: 'secondary',
    label: label,
    onClick: onClick
  });
};

var Submit = function Submit(_ref9) {
  var onClick = _ref9.onClick,
      willSubmitForm = _ref9.willSubmitForm;
  return React.createElement(Base, {
    display: 'primary',
    label: 'Submit',
    onClick: onClick,
    willSubmitForm: willSubmitForm
  });
};

var baseProps = {
  /** Function invoked when button is clicked. */
  onClick: PropTypes.func.isRequired
};

var primaryVariantProps = _extends({}, baseProps, {
  /** When set, will change button type from 'button' to 'submit'. */
  willSubmitForm: PropTypes.bool
});

Base.propTypes = _extends({}, baseProps, {
  /** Sets the display type, controls the styling. */
  display: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,

  /** Button label. */
  label: PropTypes.string.isRequired,

  /** When set, will change button type from 'button' to 'submit'. */
  willSubmitForm: PropTypes.bool
});
Base.defaultProps = {
  willSubmitForm: false
};
Back.propTypes = _extends({}, baseProps);
Cancel.propTypes = _extends({}, baseProps);
Confirm.propTypes = _extends({}, primaryVariantProps);
Continue.propTypes = _extends({}, primaryVariantProps);
Next.propTypes = _extends({}, primaryVariantProps);
Primary.propTypes = _extends({}, primaryVariantProps, {
  /** Button label. */
  label: PropTypes.string.isRequired
});
Secondary.propTypes = _extends({}, baseProps, {
  /** Button label. */
  label: PropTypes.string.isRequired
});
Submit.propTypes = _extends({}, primaryVariantProps);

var exampleHandler = function exampleHandler() {};

Back.defaultExample = function () {
  return React.createElement(Back, {
    onClick: exampleHandler
  });
};

Cancel.defaultExample = function () {
  return React.createElement(Cancel, {
    onClick: exampleHandler
  });
};

Confirm.defaultExample = function () {
  return React.createElement(Confirm, {
    onClick: exampleHandler
  });
};

Continue.defaultExample = function () {
  return React.createElement(Continue, {
    onClick: exampleHandler
  });
};

Next.defaultExample = function () {
  return React.createElement(Next, {
    onClick: exampleHandler
  });
};

Primary.defaultExample = function () {
  return React.createElement(Primary, {
    label: 'Button label',
    onClick: exampleHandler
  });
};

Secondary.defaultExample = function () {
  return React.createElement(Secondary, {
    label: 'Button label',
    onClick: exampleHandler
  });
};

Submit.defaultExample = function () {
  return React.createElement(Submit, {
    onClick: exampleHandler
  });
};

var NavigationButton = {
  Back: Back,
  Cancel: Cancel,
  Confirm: Confirm,
  Continue: Continue,
  Next: Next,
  Primary: Primary,
  Secondary: Secondary,
  Submit: Submit
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: wrap;\n'], ['\n\tdisplay: flex;\n\tflex-wrap: wrap;\n']),
    _templateObject2 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-basis: 100%;\n'], ['\n\tdisplay: flex;\n\tflex-basis: 100%;\n']);

var StyledWrapper$1 = styled('div')(_templateObject$2);
var StyledTertiaryButtons = styled('div')(_templateObject2);

var NavigationButtonGroup = function NavigationButtonGroup(_ref) {
  var primaryButton = _ref.primaryButton,
      secondaryButtons = _ref.secondaryButtons,
      tertiaryButtons = _ref.tertiaryButtons;
  return React.createElement(StyledWrapper$1, null, secondaryButtons, primaryButton, tertiaryButtons && React.createElement(StyledTertiaryButtons, null, tertiaryButtons));
};

NavigationButtonGroup.propTypes = {
  /** Primary button child. Should be a <NavigationButton.Variant> component of primary style. */
  primaryButton: PropTypes.node.isRequired,

  /** Secondary buttons, either as a single <NavigationButton.Variant> component, or an array of the same. */
  secondaryButtons: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,

  /** Tertiary buttons, either as a single <NavigationButton.Variant> component, or an array of the same. */
  tertiaryButtons: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};
NavigationButtonGroup.defaultProps = {};

NavigationButtonGroup.defaultExample = function () {
  return React.createElement(NavigationButtonGroup, {
    primaryButton: React.createElement(NavigationButton.Next, {
      onClick: function onClick() {}
    }),
    secondaryButtons: React.createElement(NavigationButton.Back, {
      onClick: function onClick() {}
    })
  });
};

export { NavigationButton, NavigationButtonGroup };